import { render, staticRenderFns } from "./RegisterProduct.vue?vue&type=template&id=3eafd358"
import script from "./RegisterProduct.vue?vue&type=script&lang=js"
export * from "./RegisterProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports